<script>
import { Base64 } from 'js-base64'
import { getAuthUrl } from '@/api/auth'

export default {
  name: 'Login',
  created() {
    // const returnUrl = `${window.location.origin}/#${this.$route.query.returnPath || '/'}`
    const returnUrl = `${window.location.origin}${this.$route.query.returnPath || '/'}`
    const ps = Base64.encode(JSON.stringify({ 'returnUrl': `${returnUrl}`, 'serviceCode': 'Cargo', 'checkLoginRule': 'true' }))
    getAuthUrl().then(res => {
      let authUrl = ''
      if (res.data.trim()) {
        authUrl = `${res.data}?ps=${ps}`
      } else {
        authUrl = `${process.env.VUE_APP_AUTH_URL}?ps=${ps}`
      }
      // authUrl = `http://localhost:8080/LoginServlet?ps=${ps}`
      // console.log('authUrl--------------', authUrl)
      window.location.href = authUrl
    })
  },
  render: function(h) {
    return h() // avoid warning message
  }
}
</script>
